import { EBSession } from "./session";
import { showErrorToast } from "./toast";
import { EBUploadManager } from "./uploads";

export function setupTinyMCEEditors(baseElement, file_picker_callback = undefined) { //opts = {}) {
    try {
        baseElement.querySelectorAll(`textarea:not(.nowysiwyg)`).forEach(element => {
            try {
                tinymce.init({
                    target: element,
                    plugins: [
                        ...(element.getAttribute("tinymce-plugins") || "advlist,autolink,lists,link,image,charmap,preview,anchor,searchreplace,visualblocks,code,fullscreen,insertdatetime,media,table,help").split(","),
                        ...["help", "code", "autoresize"], //, "ebnonedit"]
                        ... ["eb-variables", "eb-preview"],
                        ...(!!EBSession.tenant.features.platformAdministration ? ["eb-logic"] : [""])
                    ],
                    //ebpluginsinfo: element.getAttribute("data-tinymce-variables"), data-tinymce-variables="My Friendly Name|registrant.name||Event ID|event.id"
                    font_family_formats: 'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Segoe UI=segoe ui,segoe,sans-serif; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva;',
                    toolbar: element.getAttribute("tinymce-toolbar") || "blocks bold italic backcolor alignleft aligncenter alignright alignjustify bullist numlist outdent indent removeformat code eb-variables",
                    //skin: document.body.classList.contains("dark") ? "tinymce-5-dark" : "",
                    //content_css: document.body.classList.contains("dark") ? "dark" : "",
                    content_style: `.mceNonEditable { border: dashed 1px rgb(144, 164, 174); }`,
                    //noneditable_regexp: /<eb-.+?>(.+?)<\/eb-.+?>/g,
                    noneditable_regexp: /<placeholderdonotremove>(.+?)<\/placeholderdonotremove>/g,
                    promotion: false,
                    branding: false, //https://www.tiny.cloud/docs/configure/editor-appearance/#branding
                    inline: false, //element.tagName == "DIV",
                    readonly: element.hasAttribute("disabled") || element.hasAttribute("readonly"),
                    menubar: element.getAttribute("tinymce-menu") === "true",
                    valid_elements: '*[*]',
                    valid_children: "*[*]",
                    invalid_elements: 'o:p',
                    forced_root_block: "p",
                    forced_root_block_attrs: {
                        "data-ebvisible": "true"
                    },
                    font_size_formats: "8px 9px 10px 11px 12px 14px 16px 18px 20px 22px 24px 26px 28px 46px 48px 72px",
                    ui_mode: "split",
                    min_height:400,
                    max_height:800,
                    file_picker_callback: file_picker_callback,
                    statusbar: true,
                    elementpath: false,
                    allow_script_urls: true,
                    convert_urls: false,
                    resize: true,
                    link_default_target: "_blank",
                    link_assume_external_targets: true,
                    cleanup:true,
                    contextmenu: "link linkchecker image editimage table spellchecker eb-logic",
                    iframe_template_callback: (data) => {
                        const keys = Object.keys(data).filter(key => ["source", "altsource", "sourcemime", "altsourcemime", "type", "embed"])
                        return `<iframe ${keys.map(key => `${key}="${data[key]}"`).join(", ")} referrerpolicy="strict-origin-when-cross-origin" src="${data.source.replace("www.youtube.com", "www.youtube-nocookie.com")}"></iframe>`
                    },
                    paste_preprocess: function(plugin,args){
                        args.content = args.content.replace("&lt;o:p&gt;", "");
                        args.content= args.content.replace("&lt;/o:p&gt;","");
                    }, //striping the o:p stuff from pastes inside the text part, not the source part
                    //paste_as_text: true,
                    setup: (editor) => {
                        editor.on("init", (event) => {
                            document.querySelector(`label[for="${editor.targetElm.id}"]`)?.addEventListener("click", (e) => {
                                e.preventDefault();
                                e.stopImmediatePropagation();
                                editor.focus();
                            });
                            //editor.getBody().setAttribute("aria-label", document.querySelector(`label[for="${editor.targetElm.id}"]`)?.textContent() || "");                        
                            editor.setContent(editor.targetElm.value);
                            if (event.target.targetElm.hasAttribute("required") && event.target.getContent() == "")
                                event.target.editorContainer.classList.add("invalid");
                            if (event.target.targetElm.hasAttribute("disabled") || event.target.targetElm.hasAttribute("readonly")) {
                                editor.mode.set("readonly");
                            }

                            /*new MutationObserver(function(mutations) {
                                mutations.forEach(function(mutation) {
                                  if (mutation.type === "attributes" && mutation.attributeName === "disabled") {
                                    //editor.getBody().setAttribute('contenteditable', !mutation.target.hasAttribute("disabled"));
                                    editor.readonly = mutation.target.hasAttribute("disabled");
                                    editor.editorReadOnly = mutation.target.hasAttribute("disabled");
                                    editor.setDirty(true);
                                    //editor.getBody().setAttribute('contenteditable', !mutation.target.hasAttribute("disabled"));
                                  }
                                });
                            }).observe(event.target.targetElm, { attributes: true });*/
                        });
                        /*editor.on('BeforeSetContent', function (e) {
                            e.content = e.content.replace(/<o:p[^>]*>|<\/o:p>/g, ''); // Remove <o:p> tags
                        });*/
                        editor.on("SetContent", (event) => {
                            setTimeout(() => {
                                if (editor.targetElm.disabled || editor.targetElm.readonly ) {
                                    editor.mode.set("readonly");
                                }
                            }, 1000)
                        })
                        editor.get_variable_list = (types = undefined, extras = undefined) => {
                            var varListTypes = !!types ? types : (element.getAttribute("tinymce-variables-type") || "").split("|").filter(o => o != "");
                            var varListExtras = !!extras ? extras : (element.getAttribute("tinymce-variables-extra") || "").split("|").filter(o => o != "");
                            var varList = getVariablesList(varListTypes, varListExtras);
                            element.setAttribute("tinymce-variables", varList);
                            return varList;
                        }
                        editor.on('keydown', (event) => {
                            if ((event.key === "Backspace" || event.code === "Backspace") && (editor.selection.getNode().getAttribute("contenteditable") == false || editor.selection.getNode().previousSibling?.getAttribute("contenteditable") == "false" || editor.selection.getNode().previousSibling?.querySelector(".mceNonEditable")?.getAttribute("contenteditable") == "false")) {
                                event.preventDefault();
                                return false;
                            }
                            if ((event.key === "Delete" || event.code === "Delete") && (editor.selection.getNode().getAttribute("contenteditable") == false || editor.selection.getNode().nextSibling?.getAttribute("contenteditable") == "false" || editor.selection.getNode().nextSibling?.querySelector(".mceNonEditable")?.getAttribute("contenteditable") == "false")) {
                                event.preventDefault();
                                return false;
                            }
                            //if (editor.selection.getNode().getAttribute("contenteditable") == "false" || editor.selection.getNode().closest(`[contenteditable="false"]`) != null) {
                            if (editor.selection.getNode().getAttribute("contenteditable") == "false" || editor.selection.getNode().closest(`[contenteditable]`)?.getAttribute("contenteditable") == "false") {
                                event.preventDefault();
                                return false;
                            }
                        });
                        editor.on('click', (event) => {
                            if (editor.selection.getNode().getAttribute("contenteditable") == "false" || editor.selection.getNode().closest(`[contenteditable="false"]`) != null) {
                                event.preventDefault();
                                return false;
                            }
                        });
                        editor.on('contextmenu', (event) => {
                            if (editor.selection.getNode().getAttribute("contenteditable") == "false" || editor.selection.getNode().closest(`[contenteditable="false"]`) != null) {
                                event.preventDefault();
                                return false;
                            }
                        });
                        editor.on("input", () => {
                            editor.save();
                            editor.targetElm.value = editor.getContent();
                            editor.targetElm.dispatchEvent(new Event("input"));
                            if (editor.targetElm.hasAttribute("required") && editor.getContent() == "")
                                editor.editorContainer.classList.add("invalid");
                            else
                                editor.editorContainer.classList.remove("invalid");
                        });
                        editor.on("change", (event) => {
                            editor.save();
                            editor.targetElm.value = editor.getContent();
                            editor.targetElm.dispatchEvent(new Event("input"));
                            if (event.target.targetElm.hasAttribute("required") && event.target.getContent() == "")
                                event.target.editorContainer.classList.add("invalid");
                            else
                                event.target.editorContainer.classList.remove("invalid");
                        });
                        editor.on("undo", (event) => {
                            editor.save();
                            editor.targetElm.value = editor.getContent();
                            editor.targetElm.dispatchEvent(new Event("input"));
                            if (event.target.targetElm.hasAttribute("required") && event.target.getContent() == "")
                                event.target.editorContainer.classList.add("invalid");
                            else
                                event.target.editorContainer.classList.remove("invalid");
                        });
                        editor.on("redo", (event) => {
                            editor.save();
                            editor.targetElm.value = editor.getContent();
                            editor.targetElm.dispatchEvent(new Event("input"));
                            if (event.target.targetElm.hasAttribute("required") && event.target.getContent() == "")
                                event.target.editorContainer.classList.add("invalid");
                            else
                                event.target.editorContainer.classList.remove("invalid");
                        });
                        editor.get_variable_list();
                    }
                });

                element.addEventListener("change", (event) => {
                    try {
                        const editor = tinymce.get(element.id);
                        if (!editor) return;
                        if (!editor.editorContainer) return;
                        if (editor.getContent() != element.value) editor.setContent(element.value);
                        if (editor.targetElm.hasAttribute("required") && editor.getContent() == "")
                            editor.editorContainer.classList.add("invalid");
                        else
                            editor.editorContainer.classList.remove("invalid");
                    } catch (ex) {
                        console.error(ex);
                        showErrorToast(ex.message || ex);
                    }
                });
            } catch(ex) {
                console.error(ex);
                showErrorToast(ex.message || ex);
            }
        });

        if (baseElement.parentElement instanceof Node) {
            new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type !== 'childList') return;
                    if (mutation.removedNodes.length == 0) return;
                    if (mutation.removedNodes[0] !== baseElement) return;

                    baseElement.querySelectorAll(`textarea:not(.nowysiwyg)`).forEach(element => {
                        try {
                            tinymce.remove(tinymce.get(element.id));
                        } catch(ex) {
                            console.error(ex);
                        }
                    });
                });
            }).observe(baseElement.parentElement, { childList: true });
        }
    } catch(ex) {
        console.error(ex);
        showErrorToast(ex.message || ex);
    }
}

var getVariablesList = (types, extras) => {
    var ret = [];
    for (let type of types) {
        if (type == "event") {
            ret.push(...[
                "Event Name:event.title",
                "Event Subtitle:event.subtitle",
                "Event Description:{event.description}",
                "Event Identifier:event.identifier",
                "Event Begin:event.begin",
                "Event End:event.end",
                "Event Timezone:event.timezone",
                "Event Duration:event.duration",
                "Event Venue Name:event.venueName",
                "Event Venue Location:event.venueLocation",
                "Event Contact Name:event.contactDisplayText",
                "Event Contact Email:event.contactEmail",
            ]);
        }
        if (type == "registrant") {
            ret.push(...[
                //Fix the missing urls
                "Registrant First Name:registrant.firstName",
                "Registrant Last Name:registrant.lastName",
                "Registrant Email:registrant.email",
            ]);
        }
        if (type == "registrant+") {
            ret.push(...[
                "Registrant First Name:registrant.firstName",
                "Registrant Last Name:registrant.lastName",
                "Registrant Email:registrant.email",
                "Registrant Event URL:{registrationUrl}",
                "Registrant Survey URL:{surveyUrl}",
                "Registrant Certificate URL:{certificateUrl}",
            ]);
            if(!!EBSession.tenant.features.eventCommunicationQrCode){
                ret.push(...[
                    "Registrant QR Code:{attendanceQRCode}",
                ]);
            }
        }
        if (type == "tenant") {
            ret.push(...[
                //Is that url even needed???
                "Tenant Name:tenant.name",
                "Tenant Hostname:tenant.hostname",
                "Tenant Change Password URL:null"
            ]);
        }
        if (type == "account") {
            ret.push(...[
                //Account role needed?
                "Account Id:account.id",
                "Account First Name:account.firstName",
                "Account Last Name:account.lastName",
                "Account Email:account.email",
                "Account Role:null"
            ]);
        }
        if (type == "delegate") {
            ret.push(...[
                "Delegate First Name:delegate.firstName",
                "Delegate Last Name:delegate.lastName",
                "Delegate Email:delegate.email",
                "Delegate Role:delegate.role"
            ]);
        }
    }
    ret.push(...extras);
    return ret.join("|");
}